import React from 'react';
import { Button, makeStyles } from '@material-ui/core';
import { useSelector } from 'react-redux';
import { RootState } from 'state/store';
import { LoadingStates } from 'typings';
import BackspaceRoundedIcon from '@material-ui/icons/BackspaceRounded';

interface ScriptStepClearProps {
  onClear: Function;
}

const useStyles = makeStyles((theme) => ({
  container: {
    marginBottom: theme.spacing(1),
  },
  button: {
    fontWeight: 'bold',
    lineHeight: '1.5',
  },
  icon: {
    fontSize: '0.8rem',
    marginRight: theme.spacing(0.5),
  },
}));

const ScriptStepClear = ({ onClear }: ScriptStepClearProps) => {
  const styles = useStyles();

  const isLoading = useSelector(
    (state: RootState) => state.script.loadingState === LoadingStates.LOADING
  );

  return (
    <div className={styles.container}>
      <Button
        color="primary"
        className={styles.button}
        disabled={isLoading}
        onClick={() => onClear()}
      >
        <BackspaceRoundedIcon className={styles.icon} />
        Clear
      </Button>
    </div>
  );
};

export default ScriptStepClear;
